interface appSubTypeParameters {
  hasFFMApp: boolean;
  onExchange: boolean;
}

// Promise.allSetteld polyfill, since it is only available form Node 12
export const allSettled = (promises) => {
  const wrappedPromises = promises.map(p =>
    Promise.resolve(p).then(
      val => ({ status: 'fulfilled', value: val }),
      err => ({ status: 'rejected', reason: err }),
    ));
  return Promise.all(wrappedPromises);
};

export const getAppSubType = ({ hasFFMApp, onExchange }: appSubTypeParameters): string => {
  if (!onExchange) {
    return 'off';
  }
  return hasFFMApp ? 'ede' : 'sbm';
};
